import { CommonAPIService } from './CommonHandler';

export class FileAPIService {
  constructor() {
    this.CommonAPIService = new CommonAPIService();
  }

  getPDFFile(filename, type, id, router) {
    const url = `/api/files/${filename}/${type}/${id}/download`;
    return this.CommonAPIService.newFileCall(url, '', router);
  }

  uploadFile(parms, router) {
    const url = '/api/files';
    return this.CommonAPIService.fileCall(url, parms, router);
  }

  deleteFile(id, filename, router) {
    const url = `/api/claims/${id}/${filename}/delete`;
    return this.CommonAPIService.deleteCall(url, null, router);
  }
}

export default FileAPIService;
